<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">康熙年间槟榔说</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      康熙间元江知府章履成，有《元江杂记》五首：述元江风土人情，其中云：十树槟榔中户产 两栽粳稻上农田。其自注说：每树槟榔成熟，可得一金。
      稻谷一年两熟至三熟，在清初元江种槟榔已是当地人民的重要收入，有十树槟榔即等于中户产业。槟榔在元江，向来是文人骚客的重要题材，留下不少《槟榔词》，
      《槟榔赋》。元江坝子气候炎热，终年无霜，为槟榔提供了良好的生产环境。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      清初《元江府志》有种植槟榔的简略记载，当时就驰誉滇南。槟榔鲜品青果，剖开后用藤条穿串。干果称“壳槟”，将壳剥去晒干存储名“槟仁”。
      槟榔药名大腹皮，是元江民间极普遍的待客食品，故史籍上有槟榔得名于客人雅称“槟郎”的记述。成串的“槟榔吊”是家里逢年过节和办喜事的陈设品。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      “看(馈赠)槟榔”是青年男女相爱定情的特有方式。元江傣族、白族地方的男女老少都有嚼槟榔的习惯，将槟榔入口细嚼，其色渐呈殷红，染唇如蔻丹，红潮阵阵涌上面颊，像喝醉了酒。
      </p>
      


    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/binlang/3.vue